import { SET_SERVICE, SET_LOADING } from 'redux/actions/types';
import { HELPER } from 'utils';
import { trackEvent } from 'utils/Mixpanel';
import apiService from '../../utils/ApiService';
const { billerService } = apiService.getInstance();

export const setLoading = isLoading => ({
  type: SET_LOADING,
  payload: isLoading,
});

export const setService = data => ({
  type: SET_SERVICE,
  payload: data,
});

export const getService = id => async dispatch => {
  let resolve = null;
  try {
    dispatch(setLoading(true));
    const response = await billerService.get(`services/${id}`);
    resolve = response;
    if (response.status === 200) {
      dispatch(setService({}));
      const { payload } = response.data;
      dispatch(setService(payload));

      // trackPageOpen is called here because getService is only called once
      // when user open All Biller first time
      dispatch(trackPageOpen());
    } else {
      dispatch(setService({}));
    }
    dispatch(setLoading(false));
  } catch (error) {
    resolve = error;
    dispatch(setService({}));
    dispatch(setLoading(false));
  }
  return resolve;
};

export const trackPageOpen = () => dispatch => {
  const source = HELPER.getParamURL('entryPoint') || 'Organic';
  dispatch(trackEvent('Page Open', { Source: source }));
};
